import React from 'react'
import SDGText from './SDGText';
import DonateButton from './DonateButton';

function HeroSection() {
    return(
        <header className="container-fluid px-3 px-md-5 hero text-light">
            <div className='row align-items-center hero-content h-100'>
                <div className='col-12 col-lg-7'>
                    {/* Hero Badge */}
                    <div className="hero-badge mb-4">
                        <span className="badge-modern">
                            <i className="bi bi-globe-africa me-2"></i>
                            Empowering African Youth Since 2020
                        </span>
                    </div>
                    
                    {/* Main Heading */}
                    <h1 className='hero-title text-shadow-strong mb-4'>
                        Unlocking <span className='text-gender-equality hero-highlight'>Brighter Futures</span>
                    </h1> 
                    
                    {/* Subtitle */}
                    <h2 className='hero-subtitle text-shadow mb-4'>
                        Connecting generations through youth empowerment and inclusivity
                    </h2>
                    
                    {/* Dynamic Values */}
                    <div className="hero-values mb-4">
                        <SDGText />
                    </div>
                    
                    {/* Description */}
                    <p className='hero-description text-shadow mb-5'>
                        Join us in fostering an empowered future through comprehensive youth development initiatives, encompassing education, health, and empowerment across Africa.
                    </p>
                    
                    {/* Call to Action Buttons */}
                    <div className="hero-actions d-flex flex-wrap gap-3 mb-4">
                        <DonateButton className="btn-hero btn-hero-primary">
                            <span>Support Our Mission</span>
                        </DonateButton>
                        <a href="/programs/overview" className="btn-hero btn-hero-outline">
                            <i className="bi bi-rocket-takeoff me-2"></i>
                            <span>Explore Programs</span>
                        </a>
                        <a href="/about-us/who-we-are" className="btn-hero btn-hero-outline">
                            <i className="bi bi-arrow-right me-2"></i>
                            <span>Learn More</span>
                        </a>
                    </div>
                    
                    {/* Stats */}
                    <div className="hero-stats d-flex flex-wrap gap-4 mt-4">
                        <div className="stat-item">
                            <div className="stat-number">500+</div>
                            <div className="stat-label">Youth Empowered</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">6</div>
                            <div className="stat-label">SDG Goals</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">4+</div>
                            <div className="stat-label">Partners</div>
                        </div>
                    </div>
                </div>
                
                {/* Hero Visual */}
                <div className='col-12 col-lg-5 text-center d-none d-lg-block'>
                    <div className="hero-visual-container">
                        {/* Main Visual Circle */}
                        <div className="hero-main-circle">
                            <div className="hero-center-content">
                                <i className="bi bi-people-fill hero-main-icon"></i>
                                <div className="hero-center-text">WeFlare</div>
                            </div>
                        </div>
                        
                        {/* Orbiting Elements */}
                        <div className="hero-orbit orbit-1">
                            <div className="hero-orbit-item education">
                                <i className="bi bi-mortarboard"></i>
                                <span>Education</span>
                            </div>
                        </div>
                        
                        <div className="hero-orbit orbit-2">
                            <div className="hero-orbit-item health">
                                <i className="bi bi-heart-pulse"></i>
                                <span>Health</span>
                            </div>
                        </div>
                        
                        <div className="hero-orbit orbit-3">
                            <div className="hero-orbit-item equality">
                                <i className="bi bi-gender-ambiguous"></i>
                                <span>Equality</span>
                            </div>
                        </div>
                        
                        <div className="hero-orbit orbit-4">
                            <div className="hero-orbit-item climate">
                                <i className="bi bi-tree"></i>
                                <span>Climate</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Scroll Indicator */}
            <div className="hero-scroll-indicator">
                <div className="scroll-mouse">
                    <div className="scroll-wheel"></div>
                </div>
                <span className="scroll-text">Scroll to explore</span>
            </div>
        </header>
    );
}

export default HeroSection